const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaUsuario: []
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case 'DESPESA_PRODUTO_MODO_TELA':
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'DESPESA_PRODUTO_LISTADO':
			return { ...state, lista: action.payload.data };


		case 'DESPESA_PRODUTO_SET_AGUARDANDO':
			return {
				...state,
				aguardando: action.payload
			};
		
		case 'DESPESA_PRODUTO_USUARIO_SELECT_LISTADO':
			return { ...state, listaUsuario: action.payload.data };

		default:
			return state;
	}
}
